module.exports = __webpack_public_path__ + "static/media/stop-covid.b77f8e27.png";